import React from "react"

import { Box } from "@mui/material"
import { styled } from "@mui/material/styles"

import { useTranslations } from "@cirrus/core/i18n"
import { DeliveryDialog, DeliveryDialogProps } from "@cirrus-delivery/v2/features/Dialog/shared/DeliveryDialog"

export const MockExamInfoDialog = ({ onClose, ...props }: IProps) => {
  const { i18n } = useTranslations()

  return <DeliveryDialog {...props} onClose={onClose}>
    <DeliveryDialog.ReportIcon />

    <DeliveryDialog.Title>{i18n("General:MockExam")}</DeliveryDialog.Title>

    <DeliveryDialog.Content>
      <StyledBox dangerouslySetInnerHTML={{ __html: i18n("Delivery.MockExamDialog:Content") }} />
    </DeliveryDialog.Content>

    <DeliveryDialog.Actions>
      <DeliveryDialog.ActionButton
        variant="contained"
        color="success"
        onClick={onClose}>
        {i18n("Common.Sowiso:Okay")}
      </DeliveryDialog.ActionButton>

    </DeliveryDialog.Actions>
  </DeliveryDialog>
}

interface IProps extends DeliveryDialogProps {
  onClose?: () => void
}

const StyledBox = styled(Box)({
  "& > hr": {
    border: 0,
    margin: ".4rem"
  }
})
